/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementDiscountIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementDiscountIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.29288 1.99992C7.6834 1.6094 8.31657 1.6094 8.70709 1.99992L9.70709 2.99992H12C12.5523 2.99992 13 3.44764 13 3.99992V6.29282L14 7.29282C14.3905 7.68334 14.3905 8.31651 14 8.70703L13 9.70703V11.9999C13 12.5522 12.5523 12.9999 12 12.9999H9.70709L8.70709 13.9999C8.31657 14.3904 7.6834 14.3904 7.29288 13.9999L6.29288 12.9999H3.99999C3.4477 12.9999 2.99999 12.5522 2.99999 11.9999V9.70703L1.99999 8.70703C1.60946 8.31651 1.60946 7.68334 1.99999 7.29282L2.99999 6.29282V3.99992C2.99999 3.44764 3.4477 2.99992 3.99999 2.99992H6.29288L7.29288 1.99992ZM7.99999 2.70703L6.99999 3.70703C6.81245 3.89457 6.55809 3.99992 6.29288 3.99992H3.99999V6.29282C3.99999 6.55803 3.89463 6.81239 3.70709 6.99992L2.70709 7.99992L3.70709 8.99992C3.89463 9.18746 3.99999 9.44181 3.99999 9.70703V11.9999H6.29288C6.55809 11.9999 6.81245 12.1053 6.99999 12.2928L7.99999 13.2928L8.99999 12.2928C9.18752 12.1053 9.44188 11.9999 9.70709 11.9999H12V9.70703C12 9.44181 12.1053 9.18746 12.2929 8.99992L13.2929 7.99992L12.2929 6.99992C12.1053 6.81239 12 6.55803 12 6.29282V3.99992H9.70709C9.44188 3.99992 9.18752 3.89457 8.99999 3.70703L7.99999 2.70703Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementDiscountIcon.tags = ['discount', 'badge', 'label', 'offer', 'sale'];

ElementDiscountIcon.category = 'Navigator';

ElementDiscountIcon.iconSize = 16;
